import { TFunction } from 'react-i18next';
import { showErrorToast } from '@/components';
import { IMAGE_FORMATS, MAX_IMAGE_SIZE } from '@/constants/files';
import { GetProp, UploadProps } from 'antd';

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

export const validateCategoryImage = (file: FileType, t: TFunction) => {
  const isValidImage = IMAGE_FORMATS.some((format) => `image/${format}` === file.type);
  if (!isValidImage) {
    showErrorToast({ message: t('category_incorrect_file_format') });
    return false;
  }

  const isValidSize = file.size < MAX_IMAGE_SIZE;
  if (!isValidSize) {
    showErrorToast({ message: t('category_incorrect_file_size') });
    return false;
  }

  return true;
};
